import React from 'react'
import PropTypes from 'prop-types'
import { upperFirst, reject } from 'lodash'
import { DetailList } from '@ideon-api/ideon-ui'
import Component from '../../common/Component'

export class PlanIdentifiersComponent extends Component {
  static propTypes = {
    identifiers: PropTypes.array.isRequired
  }

  get identifiers() {
    return reject(this.props.identifiers, { type: 'document_id' })
  }

  typeNameForType = (type) => type.split('_').map(upperFirst).join(' ')

  render() {
    return (
      <div>
        <DetailList.Root>
          {this.identifiers.map((identifier) => (
            <DetailList.Item
              key={`${identifier.type}-${identifier.value}`}
              label={this.typeNameForType(identifier.type)}
              value={identifier.value}
              data-testid={`identifier-${identifier.type}-${identifier.value}`}
            />
          ))}
        </DetailList.Root>
      </div>
    )
  }
}

export default PlanIdentifiersComponent
